/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, CardContent, Card, Box } from "@mui/material";
import ImageDeleteDialogPanel from "./panels/delete-dialog-panel";
import ImageDeleteDialogActions from "./actions/delete-dialog-actions";
import ImageEditContext from "../context";

const ImageDeleteDialog = (props) => {
    
    const deleteType = props.deleteType;
    
    const ctx = useContext(ImageEditContext);
    const {
        openRemove,
        setOpenRemove,
        model,
        onModelRemoved
    } = ctx;
    
    const [selectedModel, setSelectedModel] = useState();
    useEffect(() => {
        setSelectedModel(model);
    }, [model]);
    
    const handleCancel = function () {
        setOpenRemove(false);
    };
    const handleRemove = () => {
        onModelRemoved(selectedModel);
        setOpenRemove(false);
    };

    return (
        <Fragment>
            <Dialog open={openRemove} onClose={handleCancel} fullWidth={true} maxWidth='lg'>
                <Card sx={{ display: "flex", width: "100%", height: "100%", borderRadius: 0, border: 0 }}>
                    <CardContent sx={{ flex: "1 0 auto", height: "100%" }}>
                        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "row" }}>
                            
                            <ImageDeleteDialogPanel deleteType={deleteType} />
                            
                        </Box>
                    </CardContent>
                </Card>

                <ImageDeleteDialogActions
                    deleteType={deleteType}
                    handleCancel={handleCancel}
                    handleRemove={handleRemove}
                />
            </Dialog>
        </Fragment>
    );
};

export default ImageDeleteDialog;
